import { viewportActions, setProjectState } from '@starflow/app/store';
import helpers from '@starflow/app/helpers';
import { translate } from '@shakkerai/util-i18n';

const canvasMenu = [
  {
    name: 'canvas_zoom_in',
    label: translate('common_zoom_in'),
    handler: () => {
      viewportActions.zoomIn();
      return true;
    },
  },
  {
    name: 'canvas_zoom_out',
    label: translate('common_zoom_out'),
    handler: () => {
      viewportActions.zoomOut();
      return true;
    },
  },
  {
    name: 'canvas_fivview',
    label: translate('common_zoom_fit'),
    handler: () => {
      viewportActions.fitView({ animate: true });
    },
  },
];

const elementMenu = [
  // {
  //   name: 'element_extract_gen_info',
  //   label: '提取生成参数',
  //   handler: () => {},
  // },
  // {
  //   name: 'element_image_restore',
  //   label: '还原到原图',
  //   handler: () => {},
  // },
  {
    name: 'element_move_front',
    label: translate('menu_bring_front'),
    handler: ({ data }) => {
      helpers.canvas.moveElementToTop(data[0]);
    },
  },
  {
    name: 'element_move_back',
    label: translate('menu_send_back'),
    handler: ({ data }) => {
      helpers.canvas.moveElementToBottom(data[0]);
    },
  },
  {
    name: 'element_copy',
    label: translate('menu_copy'),
    handler: ({ data }) => {
      helpers.canvas.copyElement(data[0]);
    },
  },
  {
    name: 'element_delete',
    label: translate('menu_delete'),
    handler: ({ data }) => {
      helpers.canvas.removeElements(data);
    },
  },
  // {
  //   name: 'ungroup',
  //   label: translate('menu_ungroup'),
  //   visible: ({ data }) => {
  //     if (data.length !== 1 || !data[0]) return false;
  //     return data[0].split('-')[1] === 'group';
  //   },
  //   handler: ({ data }) => {
  //     console.log('xxx ungroup', data);
  //     const elements = helpers.element.ungroupElements(data);
  //     setProjectState({ elements, selection: [] });
  //   },
  // },
];

const selectionMenu = [
  {
    // 创建编组
    name: 'group_selection',
    label: translate('common_group'),
    handler: ({ data }) => {
      console.log('xxx group_selection', data);
      const [elements, group] = helpers.element.groupElements(data);
      setProjectState({ elements: elements, selection: [group.id] });
    },
  },
  {
    name: 'selection_to_image',
    label: translate('common_merge'),
    handler: ({ data }) => {
      helpers.element.convertMultiSelectionToImage(data);
    },
  },
  {
    name: 'selection_delete',
    label: translate('common_delete'),
    handler: ({ data }) => {
      helpers.canvas.removeElements(data);
    },
  },
];

export const contextMenu = {
  canvas: canvasMenu,
  element: elementMenu,
  selection: selectionMenu,
};
